import PageTitle from '@frontend/features/pages/components/PageTitle'
import { ShopLoader } from '@frontend/features/shop/components/ShopLoader'
import { usePostBySlug } from '@frontend/libs/hooks/usePost'
import ProductItem from '@scripts/frontend/features/products/components/product-item/ProductItem'
import ErrorBoundary from '@shared/ErrorBoundary'
import NotFound from '@shared/screens/NotFound'
import { __ } from '@wordpress/i18n'
import { useErrorBoundary } from 'react-error-boundary'
import toast from 'react-hot-toast'

import SignInButton from '../features/authentication/SignInButton'
import { useGetWishlist } from '../features/shop/wishlist/lib/hooks'
import useAuth from '../hooks/useAuth'

const Loader = () => {
  return (
    <div className="my-10 space-y-10">
      <div className="grid grid-cols-2 gap-x-8 gap-y-8 md:grid-cols-3">
        <ShopLoader />
      </div>
    </div>
  )
}

const AuthContent = () => {
  const { showBoundary } = useErrorBoundary()
  const { data: post, error, isLoading } = usePostBySlug('wishlist')

  if (isLoading) return <Loader />

  if (error) {
    if ((error as { code?: string })?.code === 'not_found') {
      return <NotFound />
    }
    toast.error('Failed to fetch wishlist page')
    showBoundary(error)
  }

  if (!post) {
    showBoundary('No response data')
    return <></>
  }

  document.title = post.meta.title

  return <ProductList />
}

const ProductList = () => {
  const { data, isLoading } = useGetWishlist()
  const products = data?.success ? data?.data : null

  const renderProducts = () =>
    products?.map((product) => (
      <ProductItem key={product.id} product={product} variant="wishlist" />
    ))

  return (
    <div className="grid grid-cols-2 gap-x-8 gap-y-8 md:grid-cols-3">
      {products && renderProducts()}
      {isLoading && <ShopLoader />}
    </div>
  )
}

function Content() {
  const { isLoggedIn } = useAuth()

  return (
    <div className="my-12">
      <PageTitle title={__('Wishlist', 'asavagroup')} />
      {!isLoggedIn && (
        <div className="flex min-h-[50vh] items-center justify-center">
          <div className="text-center">
            <p className="mb-6 text-center uppercase">
              {__('Please sign in to view your wishlist.', 'asavagroup')}
            </p>
            <SignInButton />
          </div>
        </div>
      )}
      {isLoggedIn && <AuthContent />}
    </div>
  )
}

export function Wishlist() {
  return (
    <ErrorBoundary>
      <Content />
    </ErrorBoundary>
  )
}

export default Wishlist
